import { Mascot } from "./Mascot";

const rewardSteps = [
  {
    title: "DEV FEES",
    description: "Fees actually received by the project after token launch.",
  },
  {
    title: "LONG-TERM HOLDERS",
    description: "Holders who meet the future loyalty eligibility terms.",
  },
  {
    title: "PLANNED REWARDS",
    description: "Potential distribution after the program rules are approved.",
  },
] as const;

export function LoyaltyHolderRewards() {
  return (
    <section className="loyalty shell" aria-labelledby="loyalty-title">
      <div className="loyalty__hero">
        <div className="loyalty__art">
          <i className="loyalty__halo" aria-hidden="true" />
          <Mascot
            mood="cheer"
            size="large"
            coin
            label="TOKIN glass mascot holding a golden coin"
          />
        </div>
        <div className="loyalty__copy">
          <span className="eyebrow">TOKIN COMMUNITY</span>
          <h2 id="loyalty-title">LOYALTY PAYS OFF.</h2>
          <p className="loyalty__subhead">DEV FEES → LOYALTY HOLDERS</p>
          <p className="loyalty__body">
            We're planning to share token-generated Dev Fees with eligible
            long-term holders of our token.
          </p>
          <p className="loyalty__support">
            Hold your tokens. Stay loyal. Stay tuned.
          </p>
        </div>
      </div>

      <ol className="loyalty-flow" aria-label="Planned loyalty rewards concept">
        {rewardSteps.map((step, index) => (
          <li key={step.title}>
            <span className="loyalty-flow__number">0{index + 1}</span>
            <div>
              <strong>{step.title}</strong>
              <p>{step.description}</p>
            </div>
          </li>
        ))}
      </ol>

      <p className="loyalty__disclosure">
        Coming Soon. Distribution terms and eligibility are not yet finalized.
        Rewards are not guaranteed.
      </p>
    </section>
  );
}
